var map = {
	"./10_percent_disc.svg": "../svg-icons/10_percent_disc.svg",
	"./1st.svg": "../svg-icons/1st.svg",
	"./2nd.svg": "../svg-icons/2nd.svg",
	"./3rd.svg": "../svg-icons/3rd.svg",
	"./adv-lense.svg": "../svg-icons/adv-lense.svg",
	"./adv-microscope.svg": "../svg-icons/adv-microscope.svg",
	"./adv-star.svg": "../svg-icons/adv-star.svg",
	"./alcon-logo-squared.svg": "../svg-icons/alcon-logo-squared.svg",
	"./alcon-logo-word.svg": "../svg-icons/alcon-logo-word.svg",
	"./alcon-rounded-logo-white.svg": "../svg-icons/alcon-rounded-logo-white.svg",
	"./alcon-rounded-logo.svg": "../svg-icons/alcon-rounded-logo.svg",
	"./ar_right--no-fill.svg": "../svg-icons/ar_right--no-fill.svg",
	"./ar_right.svg": "../svg-icons/ar_right.svg",
	"./arr-back.svg": "../svg-icons/arr-back.svg",
	"./arr-down-icon.svg": "../svg-icons/arr-down-icon.svg",
	"./arr-right-icon_blue.svg": "../svg-icons/arr-right-icon_blue.svg",
	"./arr-right-icon_white.svg": "../svg-icons/arr-right-icon_white.svg",
	"./arr-round.svg": "../svg-icons/arr-round.svg",
	"./arrow-accordion.svg": "../svg-icons/arrow-accordion.svg",
	"./arrow-cyan.svg": "../svg-icons/arrow-cyan.svg",
	"./arrow-down.svg": "../svg-icons/arrow-down.svg",
	"./arrow-dropdown-slim.svg": "../svg-icons/arrow-dropdown-slim.svg",
	"./arrow-gold-fallback.svg": "../svg-icons/arrow-gold-fallback.svg",
	"./arrow-gold.svg": "../svg-icons/arrow-gold.svg",
	"./arrow-left-circle.svg": "../svg-icons/arrow-left-circle.svg",
	"./arrow-left.svg": "../svg-icons/arrow-left.svg",
	"./arrow-right-circle.svg": "../svg-icons/arrow-right-circle.svg",
	"./arrow-right-transparent.svg": "../svg-icons/arrow-right-transparent.svg",
	"./arrow-top.svg": "../svg-icons/arrow-top.svg",
	"./arrow-white.svg": "../svg-icons/arrow-white.svg",
	"./arrow_right.svg": "../svg-icons/arrow_right.svg",
	"./back-btn-icon.svg": "../svg-icons/back-btn-icon.svg",
	"./banner-points-1.svg": "../svg-icons/banner-points-1.svg",
	"./banner-points-2.svg": "../svg-icons/banner-points-2.svg",
	"./banner-points-3.svg": "../svg-icons/banner-points-3.svg",
	"./bill-icon-2.svg": "../svg-icons/bill-icon-2.svg",
	"./blue-star-with-inset-shadow.svg": "../svg-icons/blue-star-with-inset-shadow.svg",
	"./bot-icon.svg": "../svg-icons/bot-icon.svg",
	"./burger-menu.svg": "../svg-icons/burger-menu.svg",
	"./burger.svg": "../svg-icons/burger.svg",
	"./calendar-2.svg": "../svg-icons/calendar-2.svg",
	"./calendar.svg": "../svg-icons/calendar.svg",
	"./calendar_no-fill.svg": "../svg-icons/calendar_no-fill.svg",
	"./cancel.svg": "../svg-icons/cancel.svg",
	"./card-delivery.svg": "../svg-icons/card-delivery.svg",
	"./cart.svg": "../svg-icons/cart.svg",
	"./certificate.svg": "../svg-icons/certificate.svg",
	"./check--blue.svg": "../svg-icons/check--blue.svg",
	"./check--primary-no-padding.svg": "../svg-icons/check--primary-no-padding.svg",
	"./check--primary.svg": "../svg-icons/check--primary.svg",
	"./chevron-circle-o-right.svg": "../svg-icons/chevron-circle-o-right.svg",
	"./circle-basket-empty.svg": "../svg-icons/circle-basket-empty.svg",
	"./circle-user.svg": "../svg-icons/circle-user.svg",
	"./city.svg": "../svg-icons/city.svg",
	"./clip.svg": "../svg-icons/clip.svg",
	"./clock.svg": "../svg-icons/clock.svg",
	"./close-icon.svg": "../svg-icons/close-icon.svg",
	"./close-window--blue.svg": "../svg-icons/close-window--blue.svg",
	"./close-window.svg": "../svg-icons/close-window.svg",
	"./close.svg": "../svg-icons/close.svg",
	"./confederate-hat.svg": "../svg-icons/confederate-hat.svg",
	"./contract-icon.svg": "../svg-icons/contract-icon.svg",
	"./copy.svg": "../svg-icons/copy.svg",
	"./corner.svg": "../svg-icons/corner.svg",
	"./customer.svg": "../svg-icons/customer.svg",
	"./date-check.svg": "../svg-icons/date-check.svg",
	"./delete-eshop.svg": "../svg-icons/delete-eshop.svg",
	"./delete.svg": "../svg-icons/delete.svg",
	"./download-file.svg": "../svg-icons/download-file.svg",
	"./download-icon.svg": "../svg-icons/download-icon.svg",
	"./dropdown-with-icon--arrow.svg": "../svg-icons/dropdown-with-icon--arrow.svg",
	"./dropdown-with-icon--location.svg": "../svg-icons/dropdown-with-icon--location.svg",
	"./dropdown-with-icon--phone.svg": "../svg-icons/dropdown-with-icon--phone.svg",
	"./drops-lenses.svg": "../svg-icons/drops-lenses.svg",
	"./edit--no-fill.svg": "../svg-icons/edit--no-fill.svg",
	"./edit-spec.svg": "../svg-icons/edit-spec.svg",
	"./edit.svg": "../svg-icons/edit.svg",
	"./email.svg": "../svg-icons/email.svg",
	"./eshop-additionally.svg": "../svg-icons/eshop-additionally.svg",
	"./eshop-bonus-points-s.svg": "../svg-icons/eshop-bonus-points-s.svg",
	"./eshop-bonus-points-t.svg": "../svg-icons/eshop-bonus-points-t.svg",
	"./eshop-bonus-points.svg": "../svg-icons/eshop-bonus-points.svg",
	"./eshop-calendar.svg": "../svg-icons/eshop-calendar.svg",
	"./eshop-delivery.svg": "../svg-icons/eshop-delivery.svg",
	"./eshop-pay.svg": "../svg-icons/eshop-pay.svg",
	"./eshop-star.svg": "../svg-icons/eshop-star.svg",
	"./exclamation-mark-blue.svg": "../svg-icons/exclamation-mark-blue.svg",
	"./eye--primary.svg": "../svg-icons/eye--primary.svg",
	"./eye-grey--crossed-out.svg": "../svg-icons/eye-grey--crossed-out.svg",
	"./eye-grey.svg": "../svg-icons/eye-grey.svg",
	"./eye-icon--desktop-white.svg": "../svg-icons/eye-icon--desktop-white.svg",
	"./eye-icon--desktop.svg": "../svg-icons/eye-icon--desktop.svg",
	"./eye-icon--mobile.svg": "../svg-icons/eye-icon--mobile.svg",
	"./eye.svg": "../svg-icons/eye.svg",
	"./facebook.svg": "../svg-icons/facebook.svg",
	"./favorite-like.svg": "../svg-icons/favorite-like.svg",
	"./fb-icon--blue.svg": "../svg-icons/fb-icon--blue.svg",
	"./fb-icon.svg": "../svg-icons/fb-icon.svg",
	"./fb-mess-icon-new.svg": "../svg-icons/fb-mess-icon-new.svg",
	"./fb-mess-icon.svg": "../svg-icons/fb-mess-icon.svg",
	"./filter-icon.svg": "../svg-icons/filter-icon.svg",
	"./filter-locator.svg": "../svg-icons/filter-locator.svg",
	"./form-element-error.svg": "../svg-icons/form-element-error.svg",
	"./form-element-ok.svg": "../svg-icons/form-element-ok.svg",
	"./geo.svg": "../svg-icons/geo.svg",
	"./help-info.svg": "../svg-icons/help-info.svg",
	"./help-question--blue.svg": "../svg-icons/help-question--blue.svg",
	"./help-question--no-color.svg": "../svg-icons/help-question--no-color.svg",
	"./help-question.svg": "../svg-icons/help-question.svg",
	"./human--blue.svg": "../svg-icons/human--blue.svg",
	"./human.svg": "../svg-icons/human.svg",
	"./icon-boxberry.svg": "../svg-icons/icon-boxberry.svg",
	"./icon-cataract-check.svg": "../svg-icons/icon-cataract-check.svg",
	"./icon-cataract-glasses.svg": "../svg-icons/icon-cataract-glasses.svg",
	"./icon-cataract-table-plus.svg": "../svg-icons/icon-cataract-table-plus.svg",
	"./icon-checked.svg": "../svg-icons/icon-checked.svg",
	"./icon-city-arrived.svg": "../svg-icons/icon-city-arrived.svg",
	"./icon-close-auth-modal.svg": "../svg-icons/icon-close-auth-modal.svg",
	"./icon-close-modal.svg": "../svg-icons/icon-close-modal.svg",
	"./icon-delivery.svg": "../svg-icons/icon-delivery.svg",
	"./icon-doc.svg": "../svg-icons/icon-doc.svg",
	"./icon-download.svg": "../svg-icons/icon-download.svg",
	"./icon-dropdown-black.svg": "../svg-icons/icon-dropdown-black.svg",
	"./icon-dropdown-white.svg": "../svg-icons/icon-dropdown-white.svg",
	"./icon-eye-with-tear-drop.svg": "../svg-icons/icon-eye-with-tear-drop.svg",
	"./icon-file.svg": "../svg-icons/icon-file.svg",
	"./icon-info-primary.svg": "../svg-icons/icon-info-primary.svg",
	"./icon-location.svg": "../svg-icons/icon-location.svg",
	"./icon-ozon-modal.svg": "../svg-icons/icon-ozon-modal.svg",
	"./icon-phone.svg": "../svg-icons/icon-phone.svg",
	"./icon-play.svg": "../svg-icons/icon-play.svg",
	"./icon-plus.svg": "../svg-icons/icon-plus.svg",
	"./icon-rejected.svg": "../svg-icons/icon-rejected.svg",
	"./icon-tear-drops.svg": "../svg-icons/icon-tear-drops.svg",
	"./icon-upload-check.svg": "../svg-icons/icon-upload-check.svg",
	"./icon-vk.svg": "../svg-icons/icon-vk.svg",
	"./icon-warning.svg": "../svg-icons/icon-warning.svg",
	"./info.svg": "../svg-icons/info.svg",
	"./inst-icon-mask.svg": "../svg-icons/inst-icon-mask.svg",
	"./inst-mess-icon.svg": "../svg-icons/inst-mess-icon.svg",
	"./insta-icon--blue.svg": "../svg-icons/insta-icon--blue.svg",
	"./insta-icon.svg": "../svg-icons/insta-icon.svg",
	"./instagram.svg": "../svg-icons/instagram.svg",
	"./interesting-fact.svg": "../svg-icons/interesting-fact.svg",
	"./inventory-delivery.svg": "../svg-icons/inventory-delivery.svg",
	"./like.svg": "../svg-icons/like.svg",
	"./listen-audio.svg": "../svg-icons/listen-audio.svg",
	"./locator-friend-suggest-icon.svg": "../svg-icons/locator-friend-suggest-icon.svg",
	"./locator-gift.svg": "../svg-icons/locator-gift.svg",
	"./locator-help.svg": "../svg-icons/locator-help.svg",
	"./locator-icon.svg": "../svg-icons/locator-icon.svg",
	"./locator-last-purchase-icon.svg": "../svg-icons/locator-last-purchase-icon.svg",
	"./locator-map-geo.svg": "../svg-icons/locator-map-geo.svg",
	"./locator-map-minus.svg": "../svg-icons/locator-map-minus.svg",
	"./locator-map-plus.svg": "../svg-icons/locator-map-plus.svg",
	"./logo-loyalty-club.svg": "../svg-icons/logo-loyalty-club.svg",
	"./logo-white.svg": "../svg-icons/logo-white.svg",
	"./logo.svg": "../svg-icons/logo.svg",
	"./logout-grey.svg": "../svg-icons/logout-grey.svg",
	"./loyalty-club-moiglaza.svg": "../svg-icons/loyalty-club-moiglaza.svg",
	"./magnifying-glass-plus-light.svg": "../svg-icons/magnifying-glass-plus-light.svg",
	"./main-map.svg": "../svg-icons/main-map.svg",
	"./main-phone.svg": "../svg-icons/main-phone.svg",
	"./main-refresh.svg": "../svg-icons/main-refresh.svg",
	"./main-rules.svg": "../svg-icons/main-rules.svg",
	"./main-search.svg": "../svg-icons/main-search.svg",
	"./main-shield.svg": "../svg-icons/main-shield.svg",
	"./main-truck.svg": "../svg-icons/main-truck.svg",
	"./map-with-pin.svg": "../svg-icons/map-with-pin.svg",
	"./messenger.svg": "../svg-icons/messenger.svg",
	"./metro-icon.svg": "../svg-icons/metro-icon.svg",
	"./money-delivery.svg": "../svg-icons/money-delivery.svg",
	"./month.svg": "../svg-icons/month.svg",
	"./nav-ar-down.svg": "../svg-icons/nav-ar-down.svg",
	"./nominations.svg": "../svg-icons/nominations.svg",
	"./ok.svg": "../svg-icons/ok.svg",
	"./order-contract_pending.svg": "../svg-icons/order-contract_pending.svg",
	"./order-create.svg": "../svg-icons/order-create.svg",
	"./order-done.svg": "../svg-icons/order-done.svg",
	"./p1vector-v2.svg": "../svg-icons/p1vector-v2.svg",
	"./p1vector.svg": "../svg-icons/p1vector.svg",
	"./pdf-lenses.svg": "../svg-icons/pdf-lenses.svg",
	"./pdf.svg": "../svg-icons/pdf.svg",
	"./placemark-cluster-partial-turquoise.svg": "../svg-icons/placemark-cluster-partial-turquoise.svg",
	"./placemark-cluster-turquoise.svg": "../svg-icons/placemark-cluster-turquoise.svg",
	"./placemark-cluster.svg": "../svg-icons/placemark-cluster.svg",
	"./placemark-turquoise-gift.svg": "../svg-icons/placemark-turquoise-gift.svg",
	"./placemark-turquoise.svg": "../svg-icons/placemark-turquoise.svg",
	"./placemark.svg": "../svg-icons/placemark.svg",
	"./play-pro-video.svg": "../svg-icons/play-pro-video.svg",
	"./play-video-specialist.svg": "../svg-icons/play-video-specialist.svg",
	"./play-video.svg": "../svg-icons/play-video.svg",
	"./play.svg": "../svg-icons/play.svg",
	"./podcast-icon.svg": "../svg-icons/podcast-icon.svg",
	"./point-stared.svg": "../svg-icons/point-stared.svg",
	"./points.svg": "../svg-icons/points.svg",
	"./position-delivery.svg": "../svg-icons/position-delivery.svg",
	"./present-box.svg": "../svg-icons/present-box.svg",
	"./print-icon.svg": "../svg-icons/print-icon.svg",
	"./product-card-calendar.svg": "../svg-icons/product-card-calendar.svg",
	"./product-card-color.svg": "../svg-icons/product-card-color.svg",
	"./product-card-daily.svg": "../svg-icons/product-card-daily.svg",
	"./product-card-drops.svg": "../svg-icons/product-card-drops.svg",
	"./product-card-solutions.svg": "../svg-icons/product-card-solutions.svg",
	"./product-card-vitamins.svg": "../svg-icons/product-card-vitamins.svg",
	"./promocode-button.svg": "../svg-icons/promocode-button.svg",
	"./promocode-success.svg": "../svg-icons/promocode-success.svg",
	"./r-arr-right.svg": "../svg-icons/r-arr-right.svg",
	"./r-arrow.svg": "../svg-icons/r-arrow.svg",
	"./r-attention.svg": "../svg-icons/r-attention.svg",
	"./r-bag-additionally.svg": "../svg-icons/r-bag-additionally.svg",
	"./r-bag.svg": "../svg-icons/r-bag.svg",
	"./r-bill.svg": "../svg-icons/r-bill.svg",
	"./r-blocked.svg": "../svg-icons/r-blocked.svg",
	"./r-box.svg": "../svg-icons/r-box.svg",
	"./r-burger-menu.svg": "../svg-icons/r-burger-menu.svg",
	"./r-calendar-check.svg": "../svg-icons/r-calendar-check.svg",
	"./r-calendar-clock.svg": "../svg-icons/r-calendar-clock.svg",
	"./r-calendar-ok.svg": "../svg-icons/r-calendar-ok.svg",
	"./r-calendar-rtl.svg": "../svg-icons/r-calendar-rtl.svg",
	"./r-calendar.svg": "../svg-icons/r-calendar.svg",
	"./r-call-center.svg": "../svg-icons/r-call-center.svg",
	"./r-car-delivery.svg": "../svg-icons/r-car-delivery.svg",
	"./r-cart.svg": "../svg-icons/r-cart.svg",
	"./r-certificate.svg": "../svg-icons/r-certificate.svg",
	"./r-chat-help.svg": "../svg-icons/r-chat-help.svg",
	"./r-chat.svg": "../svg-icons/r-chat.svg",
	"./r-checkmark-stroke.svg": "../svg-icons/r-checkmark-stroke.svg",
	"./r-checkmark.svg": "../svg-icons/r-checkmark.svg",
	"./r-circle-star.svg": "../svg-icons/r-circle-star.svg",
	"./r-clipboard.svg": "../svg-icons/r-clipboard.svg",
	"./r-clock.svg": "../svg-icons/r-clock.svg",
	"./r-close-window-rounded.svg": "../svg-icons/r-close-window-rounded.svg",
	"./r-copy.svg": "../svg-icons/r-copy.svg",
	"./r-delete.svg": "../svg-icons/r-delete.svg",
	"./r-discount-coupon.svg": "../svg-icons/r-discount-coupon.svg",
	"./r-dislike.svg": "../svg-icons/r-dislike.svg",
	"./r-dislike_fill.svg": "../svg-icons/r-dislike_fill.svg",
	"./r-document-edit.svg": "../svg-icons/r-document-edit.svg",
	"./r-document.svg": "../svg-icons/r-document.svg",
	"./r-dots.svg": "../svg-icons/r-dots.svg",
	"./r-download.svg": "../svg-icons/r-download.svg",
	"./r-edit.svg": "../svg-icons/r-edit.svg",
	"./r-email.svg": "../svg-icons/r-email.svg",
	"./r-error.svg": "../svg-icons/r-error.svg",
	"./r-expert.svg": "../svg-icons/r-expert.svg",
	"./r-eye-close.svg": "../svg-icons/r-eye-close.svg",
	"./r-eye-profile.svg": "../svg-icons/r-eye-profile.svg",
	"./r-eye-show.svg": "../svg-icons/r-eye-show.svg",
	"./r-favorites-contour.svg": "../svg-icons/r-favorites-contour.svg",
	"./r-favorites.svg": "../svg-icons/r-favorites.svg",
	"./r-gift.svg": "../svg-icons/r-gift.svg",
	"./r-glasses.svg": "../svg-icons/r-glasses.svg",
	"./r-hat.svg": "../svg-icons/r-hat.svg",
	"./r-headphones.svg": "../svg-icons/r-headphones.svg",
	"./r-help-question.svg": "../svg-icons/r-help-question.svg",
	"./r-history.svg": "../svg-icons/r-history.svg",
	"./r-home.svg": "../svg-icons/r-home.svg",
	"./r-icon-play-fill.svg": "../svg-icons/r-icon-play-fill.svg",
	"./r-icon-stop-fill.svg": "../svg-icons/r-icon-stop-fill.svg",
	"./r-ideas.svg": "../svg-icons/r-ideas.svg",
	"./r-info.svg": "../svg-icons/r-info.svg",
	"./r-iol.svg": "../svg-icons/r-iol.svg",
	"./r-lenses-check.svg": "../svg-icons/r-lenses-check.svg",
	"./r-lenses.svg": "../svg-icons/r-lenses.svg",
	"./r-like.svg": "../svg-icons/r-like.svg",
	"./r-like_fill.svg": "../svg-icons/r-like_fill.svg",
	"./r-link.svg": "../svg-icons/r-link.svg",
	"./r-loader.svg": "../svg-icons/r-loader.svg",
	"./r-locator-map-geo.svg": "../svg-icons/r-locator-map-geo.svg",
	"./r-locator-map-minus.svg": "../svg-icons/r-locator-map-minus.svg",
	"./r-locator-map-plus.svg": "../svg-icons/r-locator-map-plus.svg",
	"./r-locator-percent.svg": "../svg-icons/r-locator-percent.svg",
	"./r-locator-t30.svg": "../svg-icons/r-locator-t30.svg",
	"./r-lock.svg": "../svg-icons/r-lock.svg",
	"./r-logo-privilege-club.svg": "../svg-icons/r-logo-privilege-club.svg",
	"./r-logo.svg": "../svg-icons/r-logo.svg",
	"./r-minus.svg": "../svg-icons/r-minus.svg",
	"./r-next.svg": "../svg-icons/r-next.svg",
	"./r-notepad.svg": "../svg-icons/r-notepad.svg",
	"./r-payment.svg": "../svg-icons/r-payment.svg",
	"./r-percent.svg": "../svg-icons/r-percent.svg",
	"./r-personal-circle.svg": "../svg-icons/r-personal-circle.svg",
	"./r-personal-rounded.svg": "../svg-icons/r-personal-rounded.svg",
	"./r-personal.svg": "../svg-icons/r-personal.svg",
	"./r-phone.svg": "../svg-icons/r-phone.svg",
	"./r-pin-double.svg": "../svg-icons/r-pin-double.svg",
	"./r-pin.svg": "../svg-icons/r-pin.svg",
	"./r-play.svg": "../svg-icons/r-play.svg",
	"./r-plus.svg": "../svg-icons/r-plus.svg",
	"./r-point-of-issue.svg": "../svg-icons/r-point-of-issue.svg",
	"./r-present.svg": "../svg-icons/r-present.svg",
	"./r-print.svg": "../svg-icons/r-print.svg",
	"./r-promocode.svg": "../svg-icons/r-promocode.svg",
	"./r-ribbon-star.svg": "../svg-icons/r-ribbon-star.svg",
	"./r-rounded-cross.svg": "../svg-icons/r-rounded-cross.svg",
	"./r-search-filter.svg": "../svg-icons/r-search-filter.svg",
	"./r-search.svg": "../svg-icons/r-search.svg",
	"./r-settings.svg": "../svg-icons/r-settings.svg",
	"./r-sign-out.svg": "../svg-icons/r-sign-out.svg",
	"./r-star-contour.svg": "../svg-icons/r-star-contour.svg",
	"./r-star-rounded.svg": "../svg-icons/r-star-rounded.svg",
	"./r-star.svg": "../svg-icons/r-star.svg",
	"./r-success.svg": "../svg-icons/r-success.svg",
	"./r-telegram.svg": "../svg-icons/r-telegram.svg",
	"./r-text.svg": "../svg-icons/r-text.svg",
	"./r-upload.svg": "../svg-icons/r-upload.svg",
	"./r-user-photo.svg": "../svg-icons/r-user-photo.svg",
	"./r-vk.svg": "../svg-icons/r-vk.svg",
	"./r-wallet.svg": "../svg-icons/r-wallet.svg",
	"./r-wallet2.svg": "../svg-icons/r-wallet2.svg",
	"./r-water-drop.svg": "../svg-icons/r-water-drop.svg",
	"./r-whatsapp.svg": "../svg-icons/r-whatsapp.svg",
	"./r-youtube.svg": "../svg-icons/r-youtube.svg",
	"./rate-star.svg": "../svg-icons/rate-star.svg",
	"./rating-heart.svg": "../svg-icons/rating-heart.svg",
	"./rating-star.svg": "../svg-icons/rating-star.svg",
	"./ring-bell.svg": "../svg-icons/ring-bell.svg",
	"./rounded-check-mark.svg": "../svg-icons/rounded-check-mark.svg",
	"./select.svg": "../svg-icons/select.svg",
	"./share-icon.svg": "../svg-icons/share-icon.svg",
	"./slider-arr-left.svg": "../svg-icons/slider-arr-left.svg",
	"./slider-arr-right.svg": "../svg-icons/slider-arr-right.svg",
	"./sms.svg": "../svg-icons/sms.svg",
	"./soon.svg": "../svg-icons/soon.svg",
	"./specialists-close.svg": "../svg-icons/specialists-close.svg",
	"./specialists-crop.svg": "../svg-icons/specialists-crop.svg",
	"./specialists-download.svg": "../svg-icons/specialists-download.svg",
	"./square-academic-cap.svg": "../svg-icons/square-academic-cap.svg",
	"./star-rounded-edges.svg": "../svg-icons/star-rounded-edges.svg",
	"./star-turquoise.svg": "../svg-icons/star-turquoise.svg",
	"./status-formed.svg": "../svg-icons/status-formed.svg",
	"./tag-favorite.svg": "../svg-icons/tag-favorite.svg",
	"./telegram-mess-icon-new.svg": "../svg-icons/telegram-mess-icon-new.svg",
	"./telegram-mess-icon.svg": "../svg-icons/telegram-mess-icon.svg",
	"./telegram-sp.svg": "../svg-icons/telegram-sp.svg",
	"./telegram.svg": "../svg-icons/telegram.svg",
	"./time-delivery.svg": "../svg-icons/time-delivery.svg",
	"./tracking-link-icon.svg": "../svg-icons/tracking-link-icon.svg",
	"./triangle-arrow-right.svg": "../svg-icons/triangle-arrow-right.svg",
	"./user-circle.svg": "../svg-icons/user-circle.svg",
	"./viber-mess-icon.svg": "../svg-icons/viber-mess-icon.svg",
	"./viber.svg": "../svg-icons/viber.svg",
	"./vk-icon--blue.svg": "../svg-icons/vk-icon--blue.svg",
	"./vk-icon.svg": "../svg-icons/vk-icon.svg",
	"./vk-mess-icon-new.svg": "../svg-icons/vk-mess-icon-new.svg",
	"./vk-mess-icon.svg": "../svg-icons/vk-mess-icon.svg",
	"./vk-square.svg": "../svg-icons/vk-square.svg",
	"./vk.svg": "../svg-icons/vk.svg",
	"./waiting.svg": "../svg-icons/waiting.svg",
	"./warning-blue.svg": "../svg-icons/warning-blue.svg",
	"./whatsapp-mess-icon-new.svg": "../svg-icons/whatsapp-mess-icon-new.svg",
	"./whatsapp-mess-icon.svg": "../svg-icons/whatsapp-mess-icon.svg",
	"./whatsapp.svg": "../svg-icons/whatsapp.svg",
	"./xls_file_icon.svg": "../svg-icons/xls_file_icon.svg",
	"./youtube-icon--blue.svg": "../svg-icons/youtube-icon--blue.svg",
	"./youtube-icon.svg": "../svg-icons/youtube-icon.svg",
	"./zoom.svg": "../svg-icons/zoom.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "../svg-icons sync \\.svg$";